import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import FadeInSection from "./FadeInSection";

const isHorizontal = window.innerWidth < 600;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  if (isHorizontal) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  } else {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  if (isHorizontal) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`
    };
  } else {
    return {
      id: `vertical-tab-${index}`
    };
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: "theme.palette.background.paper",
    display: "flex",
    height: 300
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`
  }
}));

const JobList = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const experienceItems = {
    AICTE_Microsoft_Elevate_Copilot_Program: {
      jobTitle: "Intern @",
      duration: "DEC 2025 - JAN 2026",
      desc: [
        "Completed a structured internship focused on mastering Microsoft Copilot and integrating emerging AI technologies into development workflows.",
        "Upgraded an existing full-stack telemedicine application by utilizing Microsoft Copilot for code optimization, debugging, and feature enhancement.",
        "Presented the enhanced application as the final capstone project to demonstrate practical competency in AI-driven development."
      ]
    },
    CodeAlpha: {
      jobTitle: "Fullstack Development Intern @",
      duration: "JUL 2025 - AUG 2025",
      desc: [
        "Developed dynamic web applications using front-end and back-end technologies to create responsive and functional user interfaces.",
        "Acquired deep technical expertise in full-stack architecture, optimizing database management schemas and server-side protocols within a rigorous virtual development environment.",
        "	Successfully completing assigned project tasks with dedication, demonstrating proficiency in end-to-end software development lifecycles"
      ]
    },

    // CodeAlfyypha: {
    //   jobTitle: "Fullstack Development Intern @",
    //   duration: "JUL 2025 - AUG 2025",
    //   desc: [
    //     "Developed dynamic web applications using front-end and back-end technologies to create responsive and functional user interfaces.",
    //     "Acquired deep technical expertise in full-stack architecture, optimizing database management schemas and server-side protocols within a rigorous virtual development environment.",
    //     "	Successfully completing assigned project tasks with dedication, demonstrating proficiency in end-to-end software development lifecycles"
    //   ]
    // },
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation={!isHorizontal ? "vertical" : null}
        variant={isHorizontal ? "fullWidth" : "scrollable"}
        value={value}
        onChange={handleChange}
        className={classes.tabs}
      >
        {Object.keys(experienceItems).map((key, i) => (
          <Tab label={isHorizontal ? `0${i}.` : key} {...a11yProps(i)} />
        ))}
      </Tabs>
      {Object.keys(experienceItems).map((key, i) => (
        <TabPanel value={value} index={i}>
          <span className="joblist-job-title">
            {experienceItems[key]["jobTitle"] + " "}
          </span>
          <span className="joblist-job-company">{key}</span>
          <div className="joblist-duration">
            {experienceItems[key]["duration"]}
          </div>
          <ul className="job-description">
            {experienceItems[key]["desc"].map(function (descItem, i) {
              return (
                <FadeInSection delay={`${i + 1}00ms`}>
                  <li key={i}>{descItem}</li>
                </FadeInSection>
              );
            })}
          </ul>
        </TabPanel>
      ))}
    </div>
  );
};

export default JobList;
